/* tslint:disable-next-line cyclomatic-complexity */
export default function getClosestElement(element: any, className: string) {
    if (!document.documentElement.contains(element)) {
        return null;
    }

    if (element.closest) {
        return element.closest(`.${className}`);
    }

    const matchFn = document.body.msMatchesSelector ? 'msMatchesSelector' : 'matches';

    let ancestor = element;
    while (ancestor !== null) {
        if (ancestor[matchFn](`.${className}`)) {
            return ancestor;
        }
        ancestor = ancestor.parentElement;
    }

    return null;
}
